export default __webpack_public_path__ + "images/637773797a513332f4de8def4c3c9a2c-obstacles.webp";